import React from 'react';

import { FaLinkedin } from 'react-icons/fa';
import { FaGitlab } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <a href="https://gitlab.com/Bruno-z"  target="_blank">
    <div>
      <FaGitlab />
    </div>
     </a>

     <a href="https://www.linkedin.com/in/bruno-zilio-00b565143/"  target="_blank">
    <div>
      <FaLinkedin />
    </div>
    </a>
    
    <a href="https://github.com/Bruno-z"  target="_blank">
    <div>
      <FaGithub />
    </div>
    </a>
  </div>
);

export default SocialMedia;
